import { UcoastEl } from '@/scripts/core/UcoastEl';
import { TsDOM as q } from '@/scripts/core/TsDOM';

interface HistoryData {
    viewedProductHandles?: string[];
    viewedSearchTerms?: string[];
}

export class RecentlyViewedManager extends UcoastEl {
    static htmlSelector = 'recently-viewed-manager';
    viewedProductHandles: string[];
    viewedSearchTerms: string[];
    handle: string | undefined;
    currentSearchTerm: string | undefined;

    constructor() {
        super();
        const textContent = q.rs<HTMLScriptElement>('[type="application/json"]', this).textContent;
        if (!textContent) throw new Error('History data not found');
        const data: HistoryData = JSON.parse(textContent);
        this.viewedProductHandles = Array.isArray(data?.viewedProductHandles) ? data.viewedProductHandles : [];
        this.viewedSearchTerms = Array.isArray(data?.viewedSearchTerms) ? data.viewedSearchTerms : [];
        this.handle = this.getHandle();
        this.currentSearchTerm = this.getSearchTerm();
        this.updateViewedProducts();
        this.updateViewedSearchTerms();
        this.updateCartAttribute();
    }

    getHandle(): string | undefined {
        return window.location.href.split('?')[0].split('/products/')[1] || undefined;
    }

    getSearchTerm(): string | undefined {
        return new URLSearchParams(window.location.search).get('q') || undefined;
    }

    private updateList<T>(list: T[], newItem: T | undefined, maxLength: number): T[] {
        if (!Array.isArray(list)) {
            console.error('Expected an array, but got:', list);
            return [];
        }
        if (!newItem) return list;
        list = list.filter(item => item !== newItem);
        list.unshift(newItem);
        return list.slice(0, maxLength);
    }

    updateViewedProducts() {
        this.viewedProductHandles = this.updateList(this.viewedProductHandles, this.handle, 10);
    }

    updateViewedSearchTerms() {
        this.viewedSearchTerms = this.updateList(this.viewedSearchTerms, this.currentSearchTerm, 10);
    }

    updateCartAttribute() {
        if (!this.handle && !this.currentSearchTerm) return;
        void fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    '_viewed_product_handles': this.viewedProductHandles,
                    '_viewed_search_terms': this.viewedSearchTerms
                }
            })
        }).catch(error => {
            console.error('Failed to update cart attributes:', error);
        });
    }
}
